import React, { useState } from 'react';
import { API_URL } from '../../utils/constants';

function PasswordChange({ token }) {
  const [passwords, setPasswords] = useState({
    currentPassword: '',
    newPassword: '',
    confirmPassword: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleChange = (e) => {
    setPasswords({ ...passwords, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!passwords.currentPassword || !passwords.newPassword || !passwords.confirmPassword) {
      alert('모든 필드를 입력해주세요.');
      return;
    }

    if (passwords.newPassword.length < 4) {
      alert('새 비밀번호는 최소 4자 이상이어야 합니다.');
      return;
    }

    if (passwords.newPassword !== passwords.confirmPassword) {
      alert('새 비밀번호가 일치하지 않습니다.');
      return;
    }

    setIsSubmitting(true);
    try {
      const response = await fetch(`${API_URL}/users/change-password`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify({
          currentPassword: passwords.currentPassword,
          newPassword: passwords.newPassword
        })
      });

      // 응답의 Content-Type 확인
      const contentType = response.headers.get('content-type');
      
      if (response.ok) {
        alert('비밀번호가 변경되었습니다.');
        setPasswords({ currentPassword: '', newPassword: '', confirmPassword: '' });
      } else {
        // 404 또는 다른 에러 처리
        let errorMessage = '비밀번호 변경 실패';
        
        if (response.status === 404) {
          errorMessage = 'API 엔드포인트를 찾을 수 없습니다. 서버 설정을 확인해주세요.';
        } else if (contentType && contentType.includes('application/json')) {
          // JSON 응답인 경우에만 파싱
          const error = await response.json();
          errorMessage = error.error || error.message || errorMessage;
        } else {
          // HTML 또는 다른 형식의 응답
          errorMessage = `서버 오류 (${response.status}): ${response.statusText}`;
        }
        
        alert(errorMessage);
        console.error('비밀번호 변경 실패:', {
          status: response.status,
          statusText: response.statusText,
          contentType
        });
      }
    } catch (err) {
      console.error('비밀번호 변경 실패:', err);
      alert('비밀번호 변경 중 네트워크 오류가 발생했습니다.');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div style={{
      maxWidth: '600px',
      margin: '0 auto',
      padding: '20px'
    }}>
      {/* 헤더 */}
      <div style={{
        backgroundColor: 'white',
        borderRadius: '12px',
        padding: '30px',
        marginBottom: '20px',
        boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
      }}>
        <h2 style={{
          margin: '0 0 10px 0',
          fontSize: '28px',
          fontWeight: 'bold',
          color: '#2c3e50'
        }}>
          비밀번호 변경
        </h2>
        <p style={{
          margin: 0,
          fontSize: '14px',
          color: '#7f8c8d'
        }}>
          현재 비밀번호를 입력하고 새 비밀번호를 설정하세요.
        </p>
      </div>

      {/* 폼 */}
      <div style={{
        backgroundColor: 'white',
        borderRadius: '12px',
        padding: '30px',
        boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
      }}>
        <form onSubmit={handleSubmit} style={{ display: 'grid', gap: '20px' }}>
          <div>
            <label style={{
              display: 'block',
              marginBottom: '8px',
              fontSize: '14px',
              fontWeight: '600',
              color: '#2c3e50'
            }}>
              현재 비밀번호 *
            </label>
            <input
              type="password"
              name="currentPassword"
              value={passwords.currentPassword}
              onChange={handleChange}
              placeholder="현재 비밀번호를 입력하세요"
              style={{
                width: '100%',
                padding: '12px',
                fontSize: '14px',
                border: '2px solid #ecf0f1',
                borderRadius: '8px',
                boxSizing: 'border-box',
                outline: 'none'
              }}
              required
            />
          </div>

          <div style={{
            height: '1px',
            backgroundColor: '#ecf0f1',
            margin: '10px 0'
          }} />

          <div>
            <label style={{
              display: 'block',
              marginBottom: '8px',
              fontSize: '14px',
              fontWeight: '600',
              color: '#2c3e50'
            }}>
              새 비밀번호 *
            </label>
            <input
              type="password"
              name="newPassword"
              value={passwords.newPassword}
              onChange={handleChange}
              placeholder="새 비밀번호 (최소 4자)"
              style={{
                width: '100%',
                padding: '12px',
                fontSize: '14px',
                border: '2px solid #ecf0f1',
                borderRadius: '8px',
                boxSizing: 'border-box',
                outline: 'none'
              }}
              required
            />
          </div>

          <div>
            <label style={{
              display: 'block',
              marginBottom: '8px',
              fontSize: '14px',
              fontWeight: '600',
              color: '#2c3e50'
            }}>
              새 비밀번호 확인 *
            </label>
            <input
              type="password"
              name="confirmPassword"
              value={passwords.confirmPassword}
              onChange={handleChange}
              placeholder="새 비밀번호 재입력"
              style={{
                width: '100%',
                padding: '12px',
                fontSize: '14px',
                border: '2px solid #ecf0f1',
                borderRadius: '8px',
                boxSizing: 'border-box',
                outline: 'none'
              }}
              required
            />
          </div>

          <button
            type="submit"
            disabled={isSubmitting}
            style={{
              padding: '14px',
              backgroundColor: isSubmitting ? '#95a5a6' : '#3498db',
              color: 'white',
              border: 'none',
              borderRadius: '8px',
              cursor: isSubmitting ? 'not-allowed' : 'pointer',
              fontSize: '16px',
              fontWeight: 'bold',
              marginTop: '10px',
              transition: 'background-color 0.2s'
            }}
          >
            {isSubmitting ? '변경 중...' : '비밀번호 변경'}
          </button>
        </form>

        <div style={{
          marginTop: '20px',
          padding: '15px',
          backgroundColor: '#fff3cd',
          borderRadius: '8px',
          fontSize: '13px',
          color: '#856404',
          border: '1px solid #ffc107'
        }}>
          <strong>💡 안내</strong>
          <ul style={{ margin: '10px 0 0 0', paddingLeft: '20px' }}>
            <li>비밀번호는 최소 4자 이상이어야 합니다.</li>
            <li>변경 후에는 새 비밀번호로 다시 로그인하세요.</li>
            <li>비밀번호는 정기적으로 변경하는 것을 권장합니다.</li>
          </ul>
        </div>
      </div>
    </div>
  );
}

export default PasswordChange;
